import styled from "styled-components"

import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"
import { COLOR } from "ggx-componentlibrary/design/color/color.constants"
import { FONT_REGULAR } from "ggx-componentlibrary/design/typography/typography.constants"
import { Body } from "ggx-componentlibrary/design/typography/typography.styles"
import { Button } from "ggx-componentlibrary/components/button/button.component"

import ImageUploaderImage from "./assets/image-uploader-image.svg"

const UploadedImageContainer = styled.div`
  display: inline-block;
  position: relative;
`

const UploadedImage = styled.img`
  max-width: 160px;
  max-height: 160px;
`

const RemoveImageButton = styled.button`
  width: 24px;
  height: 24px;
  position: absolute;
  transform: translate(-50%, -50%);
  padding: 0;
  margin: 0;

  border: 1px solid ${COLOR.GREY_LIGHT};
  border-radius: 12px;
  background: ${COLOR.WHITE};
  color: ${COLOR.BLACK};
  ${FONT_REGULAR};
  line-height: 24px;
  text-align: center;
  cursor: pointer;

  &::before {
    content: "✕";
  }

  &:hover,
  &:focus {
    outline: 0;
    border-color: ${COLOR.BLUE_MEDIUM};
  }
`

const StyledImageUploaderImage = styled(ImageUploaderImage)`
  margin: ${SPACING.XS} 0 ${SPACING.S} 0;
`

const UploaderWrapper = styled.div`
  margin-top: ${SPACING.S};
`

const StyledButton = styled(Button)`
  margin-top: ${SPACING.XS};
`

const StyledError = styled(Body)`
  margin: ${SPACING.XS} 0 0;
  color: ${COLOR.RED_MEDIUM};
`

export {
  UploadedImageContainer,
  UploadedImage,
  RemoveImageButton,
  StyledImageUploaderImage,
  UploaderWrapper,
  StyledButton,
  StyledError,
}
